/* eslint-disable */
export default {
  header: 'Desactivar registro de errores',
  content:
    'Desactivar el modo de registro de errores eliminará cualquier registro de errores actual. ¿Desea continuar?',
  confirm: 'Deshabilitar',
  cancel: 'Cancelar',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
